// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Grid$Mui from "rescript-material-ui/src/Grid.bs.js";
import * as Formality from "re-formality/src/Formality.bs.js";
import * as ReactIntl from "react-intl";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core from "@material-ui/core";
import * as Formality__ReactUpdate from "re-formality/src/Formality__ReactUpdate.bs.js";
import * as App_Button$DvmAdminFrontendFr from "../../../common/components/button/App_Button.bs.js";
import * as Intl_Utils$DvmAdminFrontendFr from "../../../intl/Intl_Utils.bs.js";
import * as Utils_Form$DvmAdminFrontendFr from "../../../common/utils/Utils_Form.bs.js";
import * as App_Typography$DvmAdminFrontendFr from "../../../common/App_Typography.bs.js";
import * as App_LabeledText$DvmAdminFrontendFr from "../../../common/components/App_LabeledText.bs.js";
import * as Messages_Button$DvmAdminFrontendFr from "../../../intl/messages/Messages_Button.bs.js";
import * as App_Styles_Common$DvmAdminFrontendFr from "../../../common/styles/App_Styles_Common.bs.js";
import * as App_SelectFormInput$DvmAdminFrontendFr from "../../../common/components/input/App_SelectFormInput.bs.js";
import * as App_TextFieldFormInput$DvmAdminFrontendFr from "../../../common/components/input/App_TextFieldFormInput.bs.js";
import * as Messages_Bonuses_Manage$DvmAdminFrontendFr from "../../../intl/messages/bonuses/Messages_Bonuses_Manage.bs.js";

var validators_motive = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, param$1) {
      var motive = param.motive;
      if (param$1.requestType === "PERF") {
        return Utils_Form$DvmAdminFrontendFr.validateRequired(motive);
      } else {
        return {
                TAG: /* Ok */0,
                _0: motive
              };
      }
    })
};

var validators_freeMotive = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param, param$1) {
      return Utils_Form$DvmAdminFrontendFr.validateMaxCharacters(param.freeMotive, 100);
    })
};

var validators = {
  motive: validators_motive,
  freeMotive: validators_freeMotive
};

function initialFieldsStatuses(_input) {
  return {
          motive: /* Pristine */0,
          freeMotive: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            motive: /* Pristine */0,
            freeMotive: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  var match = fieldsStatuses.motive;
  var match_0 = match ? match._0 : Curry._2(validators.motive.validate, input, metadata);
  var match$1 = fieldsStatuses.freeMotive;
  var match_0$1 = match$1 ? match$1._0 : Curry._2(validators.freeMotive.validate, input, metadata);
  var motiveResult = match_0;
  var motiveResult$1;
  if (motiveResult.TAG === /* Ok */0) {
    var freeMotiveResult = match_0$1;
    if (freeMotiveResult.TAG === /* Ok */0) {
      return {
              TAG: /* Valid */0,
              output: {
                motive: motiveResult._0,
                freeMotive: freeMotiveResult._0
              },
              fieldsStatuses: {
                motive: /* Dirty */{
                  _0: motiveResult,
                  _1: /* Shown */0
                },
                freeMotive: /* Dirty */{
                  _0: freeMotiveResult,
                  _1: /* Shown */0
                }
              },
              collectionsStatuses: undefined
            };
    }
    motiveResult$1 = motiveResult;
  } else {
    motiveResult$1 = motiveResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            motive: /* Dirty */{
              _0: motiveResult$1,
              _1: /* Shown */0
            },
            freeMotive: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, metadata, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurMotiveField */0 :
                  var result = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.motive, validators_motive, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  motive: status,
                                  freeMotive: init.freeMotive
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurFreeMotiveField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.freeMotive, validators_freeMotive, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  motive: init.motive,
                                  freeMotive: status
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */2 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses, metadata);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              Curry._2(onSubmit, output, {
                                    notifyOnSuccess: (function (input) {
                                        Curry._1(dispatch, {
                                              TAG: /* SetSubmittedStatus */2,
                                              _0: input
                                            });
                                      }),
                                    notifyOnFailure: (function (error) {
                                        Curry._1(dispatch, {
                                              TAG: /* SetSubmissionFailedStatus */3,
                                              _0: error
                                            });
                                      }),
                                    reset: (function (param) {
                                        Curry._1(dispatch, /* Reset */5);
                                      }),
                                    dismissSubmissionResult: (function (param) {
                                        Curry._1(dispatch, /* DismissSubmissionResult */4);
                                      })
                                  });
                            })
                        };
                  break;
              case /* DismissSubmissionError */3 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */4 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */5 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateMotiveField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput, metadata, state.fieldsStatuses.motive, state.submissionStatus, validators_motive, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            motive: status,
                                            freeMotive: init.freeMotive
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateFreeMotiveField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$1, metadata, state.fieldsStatuses.freeMotive, state.submissionStatus, validators_freeMotive, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            motive: init.motive,
                                            freeMotive: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */2 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                motive: /* Pristine */0,
                                freeMotive: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                motive: /* Pristine */0,
                                freeMotive: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */3 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */4 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateMotive: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateMotiveField */0,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          updateFreeMotive: (function (nextInputFn, nextValue) {
              Curry._1(dispatch, {
                    TAG: /* UpdateFreeMotiveField */1,
                    _0: (function (__x) {
                        return Curry._2(nextInputFn, __x, nextValue);
                      })
                  });
            }),
          blurMotive: (function (param) {
              Curry._1(dispatch, /* BlurMotiveField */0);
            }),
          blurFreeMotive: (function (param) {
              Curry._1(dispatch, /* BlurFreeMotiveField */1);
            }),
          motiveResult: Formality.exposeFieldResult(state.fieldsStatuses.motive),
          freeMotiveResult: Formality.exposeFieldResult(state.fieldsStatuses.freeMotive),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.motive || match.freeMotive) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses, metadata);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              Curry._1(dispatch, /* Submit */2);
            }),
          dismissSubmissionError: (function (param) {
              Curry._1(dispatch, /* DismissSubmissionError */3);
            }),
          dismissSubmissionResult: (function (param) {
              Curry._1(dispatch, /* DismissSubmissionResult */4);
            }),
          mapSubmissionError: (function (map) {
              Curry._1(dispatch, {
                    TAG: /* MapSubmissionError */4,
                    _0: map
                  });
            }),
          reset: (function (param) {
              Curry._1(dispatch, /* Reset */5);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

var initialInput = {
  motive: "",
  freeMotive: ""
};

function Bonuses_Manage_Refuse(Props) {
  var row = Props.row;
  var manageCall = Props.manageCall;
  var intl = ReactIntl.useIntl();
  var form = useForm(Belt_Option.getWithDefault(row.requestType, "") === "PSER" ? ({
            motive: "other",
            freeMotive: ""
          }) : initialInput, {
        requestType: Belt_Option.getWithDefault(row.requestType, "")
      }, (function (param, param$1) {
          var motive = param.motive;
          Curry._3(manageCall, /* Refuse */1, motive === "other" ? param.freeMotive : motive, undefined);
        }));
  var match = Belt_Option.getWithDefault(row.requestType, "");
  var tmp;
  var exit = 0;
  switch (match) {
    case "PERF" :
    case "POOL" :
        exit = 1;
        break;
    default:
      tmp = null;
  }
  if (exit === 1) {
    var match$1 = Belt_Option.getWithDefault(row.requestType, "");
    var tmp$1;
    switch (match$1) {
      case "PERF" :
          tmp$1 = {
            hd: {
              label: {
                TAG: /* String */3,
                _0: "Aide non reversée au client"
              },
              value: "Aide non reversée au client"
            },
            tl: {
              hd: {
                label: {
                  TAG: /* String */3,
                  _0: "Erreur de code action"
                },
                value: "Erreur de code action"
              },
              tl: {
                hd: {
                  label: {
                    TAG: /* String */3,
                    _0: "Version non prévue dans l’action"
                  },
                  value: "Version non prévue dans l’action"
                },
                tl: {
                  hd: {
                    label: {
                      TAG: /* String */3,
                      _0: "Non cumulable, aide déjà validée"
                    },
                    value: "Non cumulable, aide déjà validée"
                  },
                  tl: {
                    hd: {
                      label: {
                        TAG: /* String */3,
                        _0: "Autre"
                      },
                      value: "other"
                    },
                    tl: /* [] */0
                  }
                }
              }
            }
          };
          break;
      case "POOL" :
          tmp$1 = {
            hd: {
              label: {
                TAG: /* String */3,
                _0: "Véhicule non bonifié"
              },
              value: "Véhicule non bonifié"
            },
            tl: {
              hd: {
                label: {
                  TAG: /* String */3,
                  _0: "Autre"
                },
                value: "other"
              },
              tl: /* [] */0
            }
          };
          break;
      default:
        tmp$1 = /* [] */0;
    }
    var tmp$2 = {
      label: Messages_Bonuses_Manage$DvmAdminFrontendFr.refusalMotive,
      options: tmp$1,
      value: {
        TAG: /* Single */0,
        _0: {
          value: form.input.motive,
          onChange: Curry._1(form.updateMotive, (function (input, motive) {
                  return {
                          motive: motive,
                          freeMotive: input.freeMotive
                        };
                }))
        }
      },
      id: "motive",
      className: App_Styles_Common$DvmAdminFrontendFr.Inputs.longInput
    };
    if (form.motiveResult !== undefined) {
      tmp$2.validationResult = Caml_option.valFromOption(form.motiveResult);
    }
    tmp = React.createElement(Core.Grid, {
          children: React.createElement(App_SelectFormInput$DvmAdminFrontendFr.make, tmp$2),
          item: true
        });
  }
  var tmp$3;
  if (form.input.motive === "other") {
    var tmp$4 = {
      onChange: Curry._1(form.updateFreeMotive, (function (input, freeMotive) {
              return {
                      motive: input.motive,
                      freeMotive: freeMotive
                    };
            })),
      value: form.input.freeMotive,
      className: App_Styles_Common$DvmAdminFrontendFr.Inputs.longInput,
      label: Belt_Option.getWithDefault(row.requestType, "") === "PSER" ? Messages_Bonuses_Manage$DvmAdminFrontendFr.refusalMotiveMax100 : Messages_Bonuses_Manage$DvmAdminFrontendFr.otherRefusalMotive
    };
    if (form.freeMotiveResult !== undefined) {
      tmp$4.validationResult = Caml_option.valFromOption(form.freeMotiveResult);
    }
    tmp$3 = React.createElement(Core.Grid, {
          children: React.createElement(App_TextFieldFormInput$DvmAdminFrontendFr.make, tmp$4),
          item: true
        });
  } else {
    tmp$3 = null;
  }
  return React.createElement("form", {
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  Curry._1(form.submit, undefined);
                })
            }, React.createElement(Core.Grid, {
                  children: null,
                  container: true,
                  direction: "column",
                  item: true,
                  spacing: 3
                }, React.createElement(Core.Grid, {
                      children: null,
                      container: true,
                      item: true,
                      justifyContent: "space-between"
                    }, React.createElement(Core.Grid, {
                          children: React.createElement(App_LabeledText$DvmAdminFrontendFr.make, {
                                label: Messages_Bonuses_Manage$DvmAdminFrontendFr.amountFromDealer,
                                children: Intl_Utils$DvmAdminFrontendFr.formatCurrency(intl, undefined, row.actualAmount),
                                colorChild: row.dealerHasMore ? "error" : "textPrimary"
                              }),
                          item: true
                        }), React.createElement(Core.Grid, {
                          alignItems: "flex-end",
                          children: null,
                          container: true,
                          direction: "column",
                          item: true,
                          spacing: 1,
                          xs: Grid$Mui.Xs.$$true
                        }, tmp, tmp$3)), React.createElement(Core.Grid, {
                      alignItems: "center",
                      children: null,
                      container: true,
                      item: true,
                      justifyContent: "space-between"
                    }, React.createElement(Core.Grid, {
                          children: React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                                style: {
                                  fontWeight: "bold"
                                },
                                children: intl.formatMessage(Messages_Bonuses_Manage$DvmAdminFrontendFr.refusalConfirmation),
                                variant: "bodyBig"
                              }),
                          item: true
                        }), React.createElement(Core.Grid, {
                          children: React.createElement(App_Button$DvmAdminFrontendFr.make, {
                                label: intl.formatMessage(Messages_Button$DvmAdminFrontendFr.confirm),
                                size: "medium",
                                type_: "submit"
                              }),
                          item: true
                        }))));
}

var Types;

var InputStyles;

var make = Bonuses_Manage_Refuse;

export {
  Types ,
  InputStyles ,
  Form ,
  initialInput ,
  make ,
}
/* react Not a pure module */
